module.exports = __webpack_public_path__ + "static/media/check.bc64f2e0.svg";